import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { SideBarMenu } from '../../../interfaces/system/SidebarNavConfig';
import { isEmptyValue } from '../../../utils/jsUtils';

export const getDefaultSidebarMenuConfig = (): SideBarMenu => {
  const savedValue = localStorage.getItem(LOCAL_STORAGE_KEYS.SIDEBAR_MENU);

  const defaultValue: SideBarMenu = {
    mainNavigation: [],
    systemMenu: [],
  };

  if (!savedValue) {
    return defaultValue;
  }

  const parsedValue = JSON.parse(savedValue);
  if (isEmptyValue(parsedValue)) {
    return defaultValue;
  }

  return parsedValue;
};
